import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxDateBox = _resolveComponent("DxDateBox");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createVNode(_component_DxDateBox, {
                id: identification,
                name: identification,
                disabled: disabled,
                placeholder: _ctx.placeholder,
                validationStatus: _ctx.validationState,
                "input-attr": _ctx.inputAttrInternal,
                "use-mask-behavior": true,
                "show-clear-button": _ctx.showClearButton,
                "display-format": "dd.MM.yyyy HH:mm:ss",
                type: "datetime",
                modelValue: _ctx.internalValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event)),
                onEnterKey: _ctx.onEnterKey,
                onFocusOut: _ctx.onFocusOut,
                "value-change-event": "keyup"
            }, null, 8, ["id", "name", "disabled", "placeholder", "validationStatus", "input-attr", "show-clear-button", "modelValue", "onEnterKey", "onFocusOut"])
        ]),
        _: 1
    }, 16, ["name", "error-message", "label"]));
}
